'use strict';

var template      = require('../../templates/companies/Main.html');
var CompanyView   = require('./Company');
var PaginatedList = require('commons/views/PaginatedList.js');
var loader        = require('helpers/loader');

module.exports = PaginatedList.extend({
    views: [],

    events: function() {
        return Object.assign({
            'change .js-searchbox-mpp': 'searchMpp',
            'keyup .js-searchbox-mpp': 'autoSubmitMppSearch'
        }, PaginatedList.prototype.events.apply(this));
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            discountCodes: []
        });

        this.views = [];

        this.collection.on('sync', this.render, this);
        this.collection.fetchPage(undefined, {validate: false});
        this.stopLoader = loader.startFullPage(this.$('table'));

        return this;
    },

    render: function() {
        let sortClass = this.collection.getSort().order === 'ascending' ?
            'footable-sorted-desc' : 'footable-sorted';

        this.$el.html(template({
            searchTerm: this.collection.getSearchTerm(),
            mppSearchTerm: this.collection.getMppSearchTerm(),
            total: this.collection.length,
            pagination: this.collection.getPaginationInfo(),
            sort: this.collection.getSort()
        }));

        this.collection.forEach(company => {
            this.views.push(new CompanyView({
                model: company,
                mppAdmins: this.options.mppAdmins,
                discountCodes: this.options.discountCodes
            }));

            this.$('.js-companies').append(_(this.views).last().$el);
        });

        this.$('.footable-sortable')
            .removeClass('footable-sorted-desc')
            .removeClass('footable-sorted');

        this.$('[data-sort="' + this.collection.getSort().key + '"]')
            .addClass(sortClass);

        this.stopLoader();
        return this;
    },

    autoSubmitMppSearch(ev) {
        var val = (this.$(ev.currentTarget).val() || '').trim();

        if (!_.isUndefined(this.mppSearchboxTimeout)) {
            clearTimeout(this.mppSearchboxTimeout);
        }

        if (
            (
                this.collection.getMppSearchTerm() &&
                val !== this.collection.getMppSearchTerm()
            ) && val.length >= 3
        ) {
            this.mppSearchboxTimeout = setTimeout(() => {
                this.$(ev.currentTarget).trigger('change');
            }, 1500);
        }
    },

    searchMpp(ev) {
        var $el = this.$(ev.currentTarget);
        var value = encodeURIComponent($el.val() || '').trim();

        if (!_.isUndefined(this.mppSearchboxTimeout)) {
            clearTimeout(this.mppSearchboxTimeout);
        }

        $el.prop({'disabled': true});
        this.collection.mppSearchString = value;
        this.navigate();
    },

    // TODO the brainchild of Artem, wouldn't it be nicer to use a qs?
    navigate() {
        app.mainRouter.navigate(
            'companies' +
            '/' + this.collection.getSort().key +
            '/' + this.collection.getSort().order +
            '/' + (this.collection.getSearchTerm() || '__all') +
            '/' + (this.collection.getMppSearchTerm() || '__all'),
            {trigger: true}
        );
    }
});



// WEBPACK FOOTER //
// ./app/adminManager/views/companies/Main.js